module.exports = __webpack_public_path__ + "img/slide-46-1.a0ec88df.png";